import type { FunctionComponent, HTMLAttributes } from 'react';

import { useModifiers } from '../../styles/hooks/useModifiers';

import styles from './BackToGameHolder.module.css';

export const BackToGameHolder: FunctionComponent<HTMLAttributes<HTMLDivElement>> = ({ children, className = '', ...rest }) => {
  const classNameWithMods = useModifiers(
    styles,
    'backToGameHolder',
    {},
    { withBaseClass: true, extraClassName: className }
  );
  return (
    <div className={classNameWithMods} {...rest}>
      {children}
    </div>
  );
};
